import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NickForm } from '../../forms/nick.form';
import { of } from 'rxjs';
import { CustomerService } from '../../../core/services/customer.service';
import { catchError, finalize, map } from 'rxjs/operators';
import { HandsetService } from '../../../core/services/handset.service';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-nick',
  templateUrl: './nick.component.html',
  styleUrls: ['./nick.component.scss'],
})
export class NickComponent implements OnInit {
  public loading = false;
  public errors = [];
  public form = new NickForm();
  public submitted = false;
  public imageLoaded = false;
  public URL = '/assets/images/onboarding/welcome.svg';

  @Output()
  public savedNickAction: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public loadedEvent = new EventEmitter<boolean>();

  constructor(private customerService: CustomerService,
              public handsetService: HandsetService) {

  }

  ngOnInit(): void {
    this.preloadImage();
  }

  public onSubmit = () => {
    this.submitted = true;
    this.form.markAllAsTouched();
    if (this.form.valid) {
      return this.customerService.updateNick(this.form.nick.value).pipe(
        map(() => {
          this.savedNickAction.emit(this.form.nick.value);
          // this.snackbar.open('Zapisano nick.', '', { duration: DURATION_5S });
        }),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        catchError(async (err) => {
          // this.snackbar.open('Nie udało się zapisać nicku.', '', { duration: DURATION_5S });
          finalize(() => (this.loading = false));
        }),
      )
        ;
    } else {
      return of(true);
    }
  };

  preloadImage() {
    const img = new Image();
    img.src = this.URL;
    img.onload = () => {
      this.imageLoaded = true;
      this.loadedEvent.emit(true);
    };
  }

  get nick() {
    return this.form.nick;
  }

  get nickError() {
    if (this.nick.invalid) {
      if (this.nick.errors.required) {
        return 'Nick jest wymagany';
      } else if (this.nick.errors.minlength) {
        return 'Nick musi mieć co najmniej 2 znaki';
      }
      if (this.nick.errors.maxlength) {
        return 'Nick może mieć co najwyżej 20 znaków';
      } else {
        return 'Nieznaby błąd';
      }
    }
    return null;
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
